export const TRANSFER_ORDER_LIST = 'TRANSFER_ORDER_LIST';
export const TRANSFER_ORDER_ERROR = 'TRANSFER_ORDER_ERROR';
export const TRANSFER_ORDER_CHECKALL_ITEMS_DATA =
  'TRANSFER_ORDER_CHECKALL_ITEMS_DATA';
export const TRANSFER_ORDER_UPDATE_ITEMS_DATA =
  'TRANSFER_ORDER_UPDATE_ITEMS_DATA';
export const TRANSFER_ORDER_LOADING = 'TRANSFER_ORDER_LOADING';
export const PRINT_PREVIEW_TRANSFER_LOADING = 'PRINT_PREVIEW_TRASFER_LOADING';
export const PRINT_PREVIEW_ERROR = 'PRINT_PREVIEW_ERROR';
export const CLEAR_SELECTED_TRANSFERS = 'CLEAR_SELECTED_TRANSFERS';
export const CLEAR_TRANSFER_LIST_ERROR = 'CLEAR_TRANSFER_LIST_ERROR';
export const SET_TO_DATE_MIN = 'SET_TO_DATE_MIN';
export const SET_FROM_DATE_MAX = 'SET_FROM_DATE_MAX';
export const SET_PRINT_DATA = 'SET_PRINT_DATA';



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/state/TransferOrderList/types.js